// This file contains functions to perform roving tab operations consistently

/**
 * Checks if roving tab should be applied
 * @param event The event
 */
export function isRovingTabEvent(event: KeyboardEvent) {
    return ["ArrowDown", "ArrowUp"].includes(event.key);
}

/**
 * Sets focus to the selected list item.
 * Defaults to the first item in the list.
 * @param items The list items
 */
// eslint-disable-next-line
export function focusSelectedItem(items: any[]) {
    if (!items || items.length === 0) {
        return;
    }

    let active = items.find((i) => i.selected && !i.disabled);
    active = active || items.find((i) => !i.disabled);

    if (active) {
        items.forEach((i) => (i.tabIndex = -1));
        active.tabIndex = 0;
        active.focus();
    }
}

/**
 * Move the tab index and focus the next applicable list item.
 * @param event The event
 * @param items The items of the list
 */
// eslint-disable-next-line
export function moveRovingTabIndex(event: KeyboardEvent, items: any[]) {
    if (!items || items.length === 0) {
        return;
    }

    const activeItems = items.filter((i) => !i.diabled);
    const activeItemIndex = activeItems.findIndex((i) => i.tabIndex === 0);
    items.forEach((i) => (i.tabIndex = -1));

    let nextActiveItemIndex = activeItemIndex + (event.code === "ArrowUp" ? -1 : 1);
    nextActiveItemIndex = (nextActiveItemIndex + activeItems.length) % activeItems.length;

    const nextFocusedItem = activeItems[nextActiveItemIndex];
    nextFocusedItem.tabIndex = 0;
    nextFocusedItem.focus();

    event.preventDefault();
    event.stopPropagation();
}
